<template>
<div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item
            v-if="params.colDef.CellRendererParams.currentTab() === 0 && params.colDef.CellRendererParams.checkCertificateSharePermission() && params.data.certificate_share_type === 1"
          @click="params.colDef.CellRendererParams.shareClassCertificate(params.data)"
            >Certificate Share</vs-dropdown-item
          >
           <vs-dropdown-item
            v-if="params.colDef.CellRendererParams.currentTab() === 0 && params.colDef.CellRendererParams.checkCreatePermission()"
           @click="params.colDef.CellRendererParams.duplicateClassData(params.data.class_id)"
            >Copy</vs-dropdown-item
          >
          <vs-dropdown-item
            v-if="params.colDef.CellRendererParams.currentTab() === 0 && params.colDef.CellRendererParams.checkEditPermission()"
            @click="params.colDef.CellRendererParams.openCreateModal('Edit', params.data.class_id)"
            >Edit</vs-dropdown-item
          >
           <vs-dropdown-item
             v-if="params.colDef.CellRendererParams.currentTab() === 0 && params.colDef.CellRendererParams.checkDeletePermission()"
            @click="params.colDef.CellRendererParams.openArchiveModal(params.data.class_id, 0)"
            >Archive</vs-dropdown-item
          >
           <vs-dropdown-item
           v-if="params.colDef.CellRendererParams.currentTab() === 1 && params.colDef.CellRendererParams.checkDeletePermission()"
            @click="params.colDef.CellRendererParams.openArchiveModal(params.data.class_id, 1)"
            >Unarchive</vs-dropdown-item
          > 
          <vs-dropdown-item
            v-if="params.colDef.CellRendererParams.currentTab() === 1 && params.colDef.CellRendererParams.checkDeletePermission()"
           @click="params.colDef.CellRendererParams.openDeleteModal(params.data.class_id)"
            >Delete</vs-dropdown-item
          >
         
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionCell'
}
</script>